import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { TIDYCAL_URL, scrollToSection } from "@/constants";

const LINKS = [
  { label: "Solutions", href: "#solutions" },
  { label: "Speaking", href: "#speaking" },
  { label: "Training", href: "#training" },
  { label: "About", href: "#about" },
  { label: "Results", href: "#results" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 left-0 w-full z-50 backdrop-blur-xl bg-[#FAF9F6]/70 transition-shadow duration-300 ${
        scrolled ? "border-b border-[#D8D4CA]/60" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-link"
          onClick={(e) => go(e, "#top")}
          className="font-display text-xl tracking-tight shrink-0"
        >
          Phillip <span className="italic text-primary">Banks</span> Sr.
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className="text-sm tracking-wide text-foreground/70 hover:text-foreground transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href={TIDYCAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-now-button"
            className="rounded-full bg-primary text-primary-foreground px-6 py-2.5 text-sm font-semibold hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/20 transition-transform duration-300"
          >
            Bring Phillip to Your Organization
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-[#D8D4CA]/60 bg-[#FAF9F6]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={(e) => go(e, l.href)}
                className="font-display text-2xl"
              >
                {l.label}
              </a>
            ))}
            <a
              href={TIDYCAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-book-now-button"
              className="rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-semibold text-center"
            >
              Bring Phillip to Your Organization
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
